export const scrollToSection = tabId => {
  const element = document.getElementById(tabId)
  if (!element) return
  element.style.scrollMarginTop = '100px'
  element.scrollIntoView({ behavior: 'smooth' })
}
